<template>
  <div class="container">
    <!--h4>Postech:</h4-->
    <!--div class="debug">
            <p>postech array model = {{ postechArr }}</p>
        </div-->
    <div v-if="loading">
      Loading postechs for project...
    </div>

    <div>
      <!--NavBar :navItems="postechNavItems"></NavBar>-->
      <NavBar v-model:navItems="postechNavItems" :level=4></NavBar>
    </div>

    <Suspense>
      <template #default>
        <!--RouterView></RouterView-->
        <RouterView></RouterView>
      </template>
      <template #fallback> loading project postechs... </template>
    </Suspense>

    <!--Postech worksheet -->
    <PostechWorksheet></PostechWorksheet>
    <!--p class="debug">project = {{ project }}</p>
        <p class="debug"> projectName = {{ project.projectInfo.projectName }}</p>-->
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import NavBar from '@/components/Nav-bar.vue'
import { RouterView } from 'vue-router'
import PostechWorksheet from './Postech-worksheet.vue'
import { useCurrentProject } from '@/composables/Current-project'
import type { Postech } from '@/types/types'

const { currentProject, loading } = useCurrentProject();

function compareFn(one, two){
  const a = one.text;
  const b = two.text;
  if(a < b){
      return -1;
  }else if (a > b){
      return 1;
  }
  //they must be equal
  return 0;
}

const postechNavItems = computed(() => {
  //console.log("=== postechNavItems computed ==== navKey = " + navKey.value);
  const navItems = currentProject.value.postechs.map((postech : Postech) => {
    //return { to: `/projects/${props.projectId}/postech/${postech.id}`, name: `Postech-${postech.id}` };
    return {
      to: { name: 'project_postech', params: { postechId: postech.id } },
      text: `Postech-${postech.id}`
    }
  })
  navItems.sort(compareFn);
  //navItems.push({ to: `/projects/${props.projectId}/postech/create`, name: 'New Postech' });
  navItems.push({ to: { name: 'create_postech' }, text: 'New Postech' })
 // console.log("..navItems = " + JSON.stringify(navItems));
  return navItems
})


</script>
